import type React from 'react';
import { useCallback } from 'react';

import { CropperElement } from 'src/app/shared/components/imageUpload';

import type { PhotoPreviewProps } from '../../types';
import { PlaceholderIcon } from '../PlaceholderIcon';

export const PhotoPreview: React.FC<PhotoPreviewProps> = ({
	image,
	hasCropper,
	crop,
	uploader,
	onImageCrop,
	onCroppedPreviewChange,
}) => {
	const handleUpdateImage = useCallback(
		(blob: Blob) => {
			uploader?.updateImage(blob);
			if (onCroppedPreviewChange) {
				onCroppedPreviewChange(URL.createObjectURL(blob));
			}
		},
		[uploader, onCroppedPreviewChange],
	);

	if (image && hasCropper && onImageCrop && uploader) {
		return (
			<CropperElement
				crop={crop}
				image={image}
				initialAspectRatio={1}
				minContainerWidth={120}
				updateCrop={onImageCrop}
				updateImage={handleUpdateImage}
			/>
		);
	}
	if (image) {
		return <img src={image} alt="" className="h-full w-full rounded-full object-cover" data-testid="uploaded-photo" />;
	}
	return <PlaceholderIcon />;
};
